import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { LogOut, Package, ShoppingCart, Gift, FileText } from "lucide-react";
import { ProductsManagement } from "@/components/admin/ProductsManagement";
import { BundlesManagement } from "@/components/admin/BundlesManagement";
import { OrdersManagement } from "@/components/admin/OrdersManagement";
import { ContentManagement } from "@/components/admin/ContentManagement";
import { toast } from "sonner";

export const AdminDashboardPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("products");

  const handleLogout = async () => {
    await supabase.auth.signOut();
    toast.success("Uitgelogd");
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50">
      <header className="bg-white border-b border-gray-200 shadow-sm">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <h1 className="font-serif text-2xl font-bold text-gold">
            Lunssence Admin Dashboard
          </h1>
          <Button variant="outline" onClick={handleLogout}>
            <LogOut className="w-4 h-4 mr-2" />
            Uitloggen
          </Button>
        </div>
      </header>

      <div className="container mx-auto px-4 py-8">
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="grid w-full max-w-3xl mx-auto grid-cols-4">
            <TabsTrigger value="products" className="flex items-center gap-2">
              <Package className="w-4 h-4" />
              Producten
            </TabsTrigger>
            <TabsTrigger value="bundles" className="flex items-center gap-2">
              <Gift className="w-4 h-4" />
              Bundles
            </TabsTrigger>
            <TabsTrigger value="content" className="flex items-center gap-2">
              <FileText className="w-4 h-4" />
              Content
            </TabsTrigger>
            <TabsTrigger value="orders" className="flex items-center gap-2">
              <ShoppingCart className="w-4 h-4" />
              Bestellingen
            </TabsTrigger>
          </TabsList>

          <TabsContent value="products" className="mt-8">
            <ProductsManagement />
          </TabsContent>

          <TabsContent value="bundles" className="mt-8">
            <BundlesManagement />
          </TabsContent>

          <TabsContent value="content" className="mt-8">
            <ContentManagement />
          </TabsContent>

          <TabsContent value="orders" className="mt-8">
            <OrdersManagement />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};
